//FOR ANALYTICS PAYLOAD USE LOWERCASE AND USE UNDERSCORE IN BEWTEEN TWO WORDS.

import {
  RESPONSE_MAIN_EXPERTS_SEARCH,
  REQUEST_EXPERTS,
  REQUEST_PROFILE_EXPERTS,
  RESPONSE_PROFILE_EXPERTS,
  REQUEST_AFFILIATION_PROFILE_EXPERTS,
  REQUEST_LOCATION,
  REQUEST_TRIALS,
  REQUEST_COLLABORATOR_NETWORK,
  REQUEST_PEER_REVIEW,
  REQUEST_INSTITUTE,
  RESPONSE_INSTITUTE,
  REQUEST_ORGANISATIONS,
  AFF_CREDENTIALS_REQUEST,
  AFF_CREDENTIALS_RESPONSE,
  AFF_CREDENTIALS_FAILURE,
  TOPIC_ARTICLES_REQUEST,
  EXPERT_PROFILE_PAGE_REQUEST,
  REQUEST_EXPERTS_WITH_FILTER,
  REQUEST_TRIALS_MAIN_TRIALS,
  CLINICAL_TRIAL_MORE_REQUEST,
  REQUEST_EXPERT_COLLABORATORS,
  EXPERT_CREDENTIALS_REQUEST,
  TOPIC_ARTICLES_MORE_REQUEST,
  EXPERT_ARTICLES_MORE_REQUEST,
  GET_AFF_TRIALS_REQUEST,
  GET_AFF_TRIALS_RESPONSE,
  UK_SPECIALITY_FILTER,
  UK_LOCATION_FILTER,
  USER_LOGIN_REQUEST,
  USER_REGISTER_REQUEST,
  REQUEST_KEYWORD_GRANTS,
  GET_SOCMED_CITATION_REQUEST,
  RESPONSE_EXPERTS,
  RESPONSE_AFFILIATION_PROFILE_EXPERTS,
  EXPERT_CREDENTIALS_RESPONSE,
  SENIOR_SCHEMA_RESPONSE,
  SENIOR_SCHEMA_FAILURE,
  SENIOR_SCHEMA_REQUEST,
  RESPONSE_LOCATION,
  RESPONSE_BIO_AFF,
  RESPONSE_COLLABORATOR_NETWORK,
  RESPONSE_BIO_COLLAB,
  RESPONSE_COLLABORATOR_NETWORK_PROFILE,
  RESPONSE_EXPERTS_WITH_FILTER,
  REQUEST_INSTITUTE_WITH_FILTER,
  RESPONSE_TRIALS,
  RESPONSE_PEER_REVIEW,
  RESPONSE_ORGANISATIONS,
  RESPONSE_KEYWORD_TWITTER_CONF,
  RESPONSE_USER_SEARCHES,
  // RESPONSE_KEYWORD_NETWORK,
  TOPIC_ARTICLES_RESPONSE,
  GET_SOCMED_CITATION_RESPONSE,
  FAILURE_EXPERTS,
  FAILURE_PROFILE_EXPERTS,
  FAILURE_AFFILIATION_PROFILE_EXPERTS,
  FAILURE_LOCATION,
  FAILURE_TRIALS,
  FAILURE_COLLABORATOR_NETWORK,
  TOPIC_ARTICLES_FAILURE,
  FAILURE_KEYWORD_GRANTS,
  FAILURE_PEER_REVIEW,
  FAILURE_INSTITUTE,
  FAILURE_ORGANISATIONS,
  GET_SOCMED_CITATION_FAILURE,
  GET_AFF_TRIALS_FAILURE,
  EXPERT_CREDENTIALS_FAILURE,
  REQUEST_SENIORITY_EXPERTS,
  RESPONSE_SENIORITY_EXPERTS,
  FAILURE_SENIORITY_EXPERTS,
  REQUEST_TRIALS_ID,
  RESPONSE_TRIALS_ID,
  FAILURE_TRIALS_ID,
  MLD_PROFESSIONALS_RESPONSE,
  MLD_PROFESSIONALS_FAILURE,
  MLD_PROFESSIONALS_REQUEST,
  MLD_SELECTED_LIST_PROFESSIONALS_RESPONSE,
  MLD_SELECTED_LIST_PROFESSIONALS_FAILURE,
  MLD_SELECTED_LIST_PROFESSIONALS_REQUEST,
  MLD_SHORT_LIST_PROFESSIONALS_RESPONSE,
  MLD_SHORT_LIST_PROFESSIONALS_FAILURE,
  MLD_SHORT_LIST_PROFESSIONALS_REQUEST,
  REQUEST_LOCATION_MLD,
  RESPONSE_LOCATION_MLD,
  FAILURE_LOCATION_MLD,
  MLD_SOCIAL_BODY_REQUEST,
  MLD_SOCIAL_BODY_RESPONSE,
  MLD_SOCIAL_BODY_FAILURE,
  REQUEST_MLD_TRIALS,
  RESPONSE_MLD_TRIALS,
  FAILURE_MLD_TRIALS,
  MLD_SOCIAL_CONF_REQUEST,
  MLD_SOCIAL_CONF_RESPONSE,
  MLD_SOCIAL_CONF_FAILURE,
  EURO_NETWORK_REQUEST,
  EURO_NETWORK_RESPONSE,
  EURO_NETWORK_FAILURE,
  MLD_AFFILIATIONS_RESPONSE,
  MLD_AFFILIATIONS_FAILURE,
  MLD_AFFILIATIONS_REQUEST,
  REQUEST_KOL_MAPPING,
  RESPONSE_KOL_MAPPING,
  FAILURE_KOL_MAPPING,
  REQUEST_TRIALS_INSTITUTES,
  RESPONSE_TRIALS_INSTITUTES,
  FAILURE_TRIALS_INSTITUTES,
  REQUEST_TRIALS_ENDPOINTS,
  RESPONSE_TRIALS_ENDPOINTS,
  FAILURE_TRIALS_ENDPOINTS,
  RESPONSE_DIRECT_PROFILE_SEARCH,
  FAILURE_DIRECT_PROFILE_SEARCH,
  PERSON_SIMILARITY_RESULT_RESPONSE,
  PERSON_SIMILARITY_RESULT_FAILURE,
  RESPONSE_LOCATION_TABLE,
  FAILURE_LOCATION_TABLE,
  RESPONSE_DIRECT_AFFILIATION_SEARCH,
  FAILURE_DIRECT_AFFILIATION_SEARCH,

  APP_EXPERTS_SEARCH_RESPONSE,
  APP_EXPERTS_SEARCH_FAILURE,
  APP_TRIALS_RESPONSE,
  APP_TRIALS_FAILURE,

  RESPONSE_ZOGENIX_SPAIN_SEARCH,
  FAILURE_ZOGENIX_SPAIN_SEARCH,
} from "../../actions/types";
import {
  SEARCH,
  EXPERT_PROFILE_PAGE,
  FILTER,
  MORE_RESULT,
  PROFILE_VIEW,
  AUTH,
  PEER_REVIEW,
  AFFILIATION_PROFILE_VIEW,
  FAILURE,
  SENIORITY_SCHEMA,
  MLD_SEARCH,
  KOL_MAPPING,
  TRIAL_INSTITUTE_RECRUITERS,
  TRIAL_END_POINTS
} from "./_category";

const searchRequest = (action, store) => {
  const { keyword } = action.payload;
  const pageUrl = window.location.pathname;
  const category = SEARCH;
  const action_type = action.type;
  const payload = {
    keyword,
    page_url: pageUrl
  };

  return {
    category,
    action_type,
    payload
  };
};

const affFilterRequest = (action, store) => {
  const { country, year, keyword } = action.payload;
  const pageUrl = window.location.pathname;
  const category = FILTER;
  const action_type = action.type;
  const payload = {
    ...action.payload,
    page_url: pageUrl,
    keyword,
    country,
    year
  };

  return {
    category,
    action_type,
    payload
  };
};

const seniorityRequest = (action, store) => {
  const { expert_id } = action.payload;
  const pageUrl = window.location.pathname;
  const category = SENIORITY_SCHEMA;
  const action_type = action.type;
  const payload = {
    expert_id,
    page_url: pageUrl
  };

  return {
    category,
    action_type,
    payload
  };
};

const seniorityResponse = (action, store) => {
  const {
    expert_id,
    ResultFound,
    // keyword,
    RequestTime,
    ResponseTime,
    TimeTaken
  } = action.payload;
  const pageUrl = window.location.pathname;
  const category = SENIORITY_SCHEMA;
  const action_type = action.type;

  const payload = {
    expert_id: expert_id,
    page_url: pageUrl,
    ResultFound,
    RequestTime,
    ResponseTime,
    TimeTaken
  };

  return {
    category,
    action_type,
    payload
  };
};

const seniorityFailure = (action, store) => {
  const {
    expert_id,
    ResultFound,
    // keyword,
    RequestTime,
    ResponseTime,
    TimeTaken
  } = action.payload;
  const pageUrl = window.location.pathname;
  const category = SENIORITY_SCHEMA;
  const action_type = action.type;

  const payload = {
    expert_id: expert_id,
    page_url: pageUrl,
    ResultFound,
    RequestTime,
    ResponseTime,
    TimeTaken
  };

  return {
    category,
    action_type,
    payload
  };
};

const expertCredentialsFailure = (action, store) => {
  const {
    expert_id,
    ResultFound,
    // keyword,
    RequestTime,
    ResponseTime,
    TimeTaken
  } = action.payload;
  const pageUrl = window.location.pathname;
  const category = PROFILE_VIEW;
  const action_type = action.type;

  const payload = {
    expert_id: expert_id,
    page_url: pageUrl,
    ResultFound,
    RequestTime,
    ResponseTime,
    TimeTaken
  };

  return {
    category,
    action_type,
    payload
  };
};

const affCredentialsFailure = (action, store) => {
  const {
    id,
    ResultFound,
    // keyword,
    RequestTime,
    ResponseTime,
    TimeTaken
  } = action.payload;
  const pageUrl = window.location.pathname;
  const category = AFFILIATION_PROFILE_VIEW;
  const action_type = action.type;

  const payload = {
    id: id,
    page_url: pageUrl,
    ResultFound,
    RequestTime,
    ResponseTime,
    TimeTaken
  };

  return {
    category,
    action_type,
    payload
  };
};

const peerReviewRequest = (action, store) => {
  // const { text } = action.payload;
  const pageUrl = window.location.pathname;
  const category = PEER_REVIEW;
  const action_type = action.type;
  const payload = {
    // text,
    page_url: pageUrl
  };

  return {
    category,
    action_type,
    payload
  };
};

const searchResponse = (action, store) => {
  const pageUrl = window.location.pathname+window.location.search;
  const category = SEARCH;
  const action_type = action.type;
  const {
    ResultFound,
    keyword,
    RequestTime,
    ResponseTime,
    TimeTaken,
    keywords,
    filters
  } = action.payload;
  const payload = {
    ResultFound,
    keywords,
    filters,
    pageUrl,
    RequestTime,
    ResponseTime,
    TimeTaken
  };

  return {
    category,
    action_type,
    payload
  };
};

const spainSearchResponse = (action, store) => {
  const pageUrl = window.location.pathname+window.location.search;
  const category = SEARCH;
  const action_type = action?.type;
  let payload = action?.payload || {};
  let RequestTime = payload?.RequestTime;
  let ResponseTime = payload?.ResponseTime;
  let ResultFound = payload?.ResultFound;
  let TimeTaken = payload?.TimeTaken;
  payload = { RequestTime, ResponseTime, ResultFound, TimeTaken, pageUrl };
  return {
    category,
    action_type,
    payload
  }
};

const spainSearchFailure = (action, store) => {
  const pageUrl = window.location.pathname+window.location.search;
  const category = FAILURE;
  const action_type = action?.type;
  let payload = action?.payload || {};
  payload = { ...payload, pageUrl };

  return {
    category,
    action_type,
    payload
  }
}

const MldsearchResponse = (action, store) => {
  const pageUrl = window.location.pathname;
  const category = MLD_SEARCH;
  const action_type = action.type;
  const {
    ResultFound,
    size,
    from,
    activeSortItem,
    activePage,
    terms,
    country,
    selectedExperts,
    selectedUniversity,
    // university,
    RequestTime,
    ResponseTime,
    TimeTaken
  } = action.payload;
  const payload = {
    ResultFound,
    size,
    from,
    activeSortItem,
    activePage,
    terms,
    country,
    selectedExperts,
    selectedUniversity,
    // university,
    pageUrl,
    RequestTime,
    ResponseTime,
    TimeTaken
  };

  return {
    category,
    action_type,
    payload
  };
};

const KOLsearchResponse = (action, store) => {
  const pageUrl = window.location.pathname;
  const category = KOL_MAPPING;
  const action_type = action.type;
  const {
    ResultFound,
    internal_kol,
    target_kol,
    terms,
    // university,
    RequestTime,
    ResponseTime,
    TimeTaken
  } = action.payload;
  const payload = {
    ResultFound,
    internal_kol,
    target_kol,
    terms,
    pageUrl,
    RequestTime,
    ResponseTime,
    TimeTaken
  };

  return {
    category,
    action_type,
    payload
  };
};

const TrialsRsearchResponse = (action, store) => {
  const pageUrl = window.location.pathname;
  const category = TRIAL_INSTITUTE_RECRUITERS;
  const action_type = action.type;
  const {
    ResultFound,
    type,
    keyword,
    country,
    last_update_posted,
    study_first_posted,
    study_type,
    phase,
    RequestTime,
    ResponseTime,
    TimeTaken
  } = action.payload;
  const payload = {
    ResultFound,
    type,
    keyword,
    country,
    last_update_posted,
    study_first_posted,
    study_type,
    phase,
    pageUrl,
    RequestTime,
    ResponseTime,
    TimeTaken
  };

  return {
    category,
    action_type,
    payload
  };
};

const TrialsEndPointResponse = (action, store) => {
  const pageUrl = window.location.pathname;
  const category = TRIAL_END_POINTS;
  const action_type = action.type;
  const {
    ResultFound,
    type,
    keyword,
    country,
    last_update_posted,
    study_first_posted,
    study_type,
    phase,
    RequestTime,
    ResponseTime,
    TimeTaken
  } = action.payload;
  const payload = {
    ResultFound,
    type,
    keyword,
    country,
    last_update_posted,
    study_first_posted,
    study_type,
    phase,
    pageUrl,
    RequestTime,
    ResponseTime,
    TimeTaken
  };

  return {
    category,
    action_type,
    payload
  };
};

const MldsearchFailure = (action, store) => {
  const pageUrl = window.location.pathname;
  const category = FAILURE;
  const action_type = action.type;
  const {
    // ResultFound,
    // keyword,
    RequestTime,
    ResponseTime,
    TimeTaken
  } = action.payload;
  const payload = {
    // ResultFound,
    // keyword,
    pageUrl,
    RequestTime,
    ResponseTime,
    TimeTaken
  };

  return {
    category,
    action_type,
    payload
  };
};

const failureResponse = (action, store) => {
  const pageUrl = window.location.pathname;
  const category = FAILURE;
  const action_type = action.type;
  const {
    // ResultFound,
    keyword,
    RequestTime,
    ResponseTime,
    TimeTaken
  } = action.payload;
  const payload = {
    // ResultFound,
    keyword,
    pageUrl,
    RequestTime,
    ResponseTime,
    TimeTaken
  };

  return {
    category,
    action_type,
    payload
  };
};

const peerResponse = (action, store) => {
  const pageUrl = window.location.pathname;
  const category = PEER_REVIEW;
  const action_type = action.type;
  const {
    ResultFound,
    text,
    RequestTime,
    ResponseTime,
    TimeTaken,
    keywords
  } = action.payload;
  const payload = {
    ResultFound,
    text,
    keywords,
    pageUrl,
    RequestTime,
    ResponseTime,
    TimeTaken
  };

  return {
    category,
    action_type,
    payload
  };
};

const expertProfileRequest = (action, store) => {
  const { expert_id } = action.payload;
  const pageUrl = window.location.pathname;
  const category = EXPERT_PROFILE_PAGE;
  const action_type = action.type;
  const payload = {
    expert_id,
    page_url: pageUrl
  };

  return {
    category,
    action_type,
    payload
  };
};

const filterRequest = (action, store) => {
  const pageUrl = window.location.pathname;
  const category = FILTER;
  const action_type = action.type;
  const payload = {
    ...action.payload,
    page_url: pageUrl
  };

  return {
    category,
    action_type,
    payload
  };
};

const fetchMoreResult = (action, store) => {
  const { from, size } = action.payload;
  const pageUrl = window.location.pathname;
  const category = MORE_RESULT;
  const action_type = action.type;

  let state = store.getState();
  let keyword = state.Global.keyword;

  const payload = {
    keyword,
    page_url: pageUrl,
    from,
    size
  };

  return {
    category,
    action_type,
    payload
  };
};

const getCollabsInfo = (action, store) => {
  const { id, keyword } = action.payload;
  const pageUrl = window.location.pathname;
  const category = SEARCH;
  const action_type = action.type;
  const payload = {
    expert_id: id,
    page_url: pageUrl,
    keyword: keyword
  };

  return {
    category,
    action_type,
    payload
  };
};

const expertProfileView = (action, store) => {
  const { expert_id } = action.payload;
  const pageUrl = window.location.pathname;
  const category = PROFILE_VIEW;
  const action_type = action.type;

  const payload = {
    expert_id: expert_id,
    page_url: pageUrl
  };

  return {
    category,
    action_type,
    payload
  };
};

const affProfileView = (action, store) => {
  const { id } = action.payload;
  const pageUrl = window.location.pathname;
  const category = AFFILIATION_PROFILE_VIEW;
  const action_type = action.type;

  const payload = {
    aff_id: id,
    page_url: pageUrl
  };

  return {
    category,
    action_type,
    payload
  };
};

const expertProfileResponse = (action, store) => {
  const {
    expert_id,
    ResultFound,
    // keyword,
    RequestTime,
    ResponseTime,
    TimeTaken
  } = action.payload;
  const pageUrl = window.location.pathname;
  const category = PROFILE_VIEW;
  const action_type = action.type;

  const payload = {
    expert_id: expert_id,
    page_url: pageUrl,
    ResultFound,
    RequestTime,
    ResponseTime,
    TimeTaken
  };

  return {
    category,
    action_type,
    payload
  };
};

const affProfileResponse = (action, store) => {
  const {
    id,
    ResultFound,
    // keyword,
    RequestTime,
    ResponseTime,
    TimeTaken
  } = action.payload;
  const pageUrl = window.location.pathname;
  const category = AFFILIATION_PROFILE_VIEW;
  const action_type = action.type;

  const payload = {
    aff_id: id,
    page_url: pageUrl,
    ResultFound,
    RequestTime,
    ResponseTime,
    TimeTaken
  };

  return {
    category,
    action_type,
    payload
  };
};

const Auth = (action, store) => {
  const pageUrl = window.location.pathname;
  const category = AUTH;
  const action_type = action.type;
  const payload = {
    ...payload,
    page_url: pageUrl
  };

  return {
    category,
    action_type,
    payload
  };
};

const multiSearchRequest = (action, store) => {
  const pageUrl = window.location.pathname;
  const category = SEARCH;
  const action_type = action.type;
  let data = action.payload || {};
  let keywords = data.keywords || [];

  const payload = {
    keywords: keywords,
    page_url: pageUrl
  };

  return {
    category,
    action_type,
    payload
  };
};

const multiAndSingleRequest = (action, store) => {
  let data = action.payload || {};
  let isMultiSearch = data.isMultiSearch;

  if (isMultiSearch) {
    return multiSearchRequest(action, store);
  }

  const { keyword } = action.payload;
  const pageUrl = window.location.pathname;
  const category = SEARCH;
  const action_type = action.type;
  const payload = {
    keyword,
    page_url: pageUrl
  };

  return {
    category,
    action_type,
    payload
  };
};

const commonResponse = (action, payload) => {
  const pageUrl = window.location.pathname+window.location.search;
  const category = SEARCH;
  const action_type = action.type;

  let data = action.payload || {};
  let { RequestTime, ResponseTime, ResultFound, TimeTaken } = data;

  payload = {
    ...payload,
    page_url: pageUrl,
    RequestTime,
    ResponseTime,
    ResultFound,
    TimeTaken
  };

  return {
    category,
    action_type,
    payload
  };
};

const eventTypesMap = {
  // [REQUEST_EXPERTS]: multiAndSingleRequest,
  // [REQUEST_EXPERTS]: searchRequest,
  // [REQUEST_PROFILE_EXPERTS]: searchRequest,
  // [REQUEST_AFFILIATION_PROFILE_EXPERTS]: searchRequest,
  // [REQUEST_LOCATION]: searchRequest,
  // [REQUEST_TRIALS]: searchRequest,
  // [REQUEST_COLLABORATOR_NETWORK]: searchRequest,
  // [REQUEST_PEER_REVIEW]: peerReviewRequest,
  // [REQUEST_INSTITUTE]: searchRequest,
  // [REQUEST_ORGANISATIONS]: searchRequest,
  // [REQUEST_SENIORITY_EXPERTS]: searchRequest,
  // [SENIOR_SCHEMA_REQUEST]: seniorityRequest,
  // [AFF_CREDENTIALS_REQUEST]: affProfileView,
  // [TOPIC_ARTICLES_REQUEST]: searchRequest,
  // [EXPERT_PROFILE_PAGE_REQUEST]: expertProfileRequest,
  [REQUEST_EXPERTS_WITH_FILTER]: filterRequest,
  [REQUEST_TRIALS_MAIN_TRIALS]: filterRequest,
  // [CLINICAL_TRIAL_MORE_REQUEST]: fetchMoreResult,
  // [REQUEST_EXPERT_COLLABORATORS]: getCollabsInfo,
  // [EXPERT_CREDENTIALS_REQUEST]: expertProfileView,
  // [TOPIC_ARTICLES_MORE_REQUEST]: fetchMoreResult,
  // [EXPERT_ARTICLES_MORE_REQUEST]: fetchMoreResult,
  // [GET_AFF_TRIALS_REQUEST]: searchRequest,
  [GET_AFF_TRIALS_RESPONSE]: searchResponse,
  [UK_SPECIALITY_FILTER]: filterRequest,
  [UK_LOCATION_FILTER]: filterRequest,
  [USER_LOGIN_REQUEST]: Auth,
  [USER_REGISTER_REQUEST]: Auth,
  // [REQUEST_KEYWORD_GRANTS]: searchRequest,
  // [GET_SOCMED_CITATION_REQUEST]:searchRequest,
  [EXPERT_CREDENTIALS_RESPONSE]: expertProfileResponse,
  [AFF_CREDENTIALS_RESPONSE]: affProfileResponse,
  [RESPONSE_MAIN_EXPERTS_SEARCH]: searchResponse,
  [RESPONSE_PROFILE_EXPERTS]: searchResponse,
  [RESPONSE_AFFILIATION_PROFILE_EXPERTS]: searchResponse,
  [RESPONSE_BIO_AFF]: searchResponse,
  [RESPONSE_BIO_COLLAB]: searchResponse,
  [RESPONSE_COLLABORATOR_NETWORK_PROFILE]: searchResponse,
  [RESPONSE_EXPERTS_WITH_FILTER]: searchResponse,
  [RESPONSE_TRIALS]: searchResponse,
  [RESPONSE_PEER_REVIEW]: peerResponse,
  [RESPONSE_INSTITUTE]: searchResponse,
  [SENIOR_SCHEMA_RESPONSE]: seniorityResponse,
  [RESPONSE_KEYWORD_TWITTER_CONF]: searchResponse,
  [RESPONSE_USER_SEARCHES]: searchResponse,
  // [REQUEST_INSTITUTE_WITH_FILTER]: affFilterRequest,
  // [RESPONSE_KEYWORD_NETWORK]:searchResponse,
  [TOPIC_ARTICLES_RESPONSE]: searchResponse,
  [GET_SOCMED_CITATION_RESPONSE]: searchResponse,
  [RESPONSE_SENIORITY_EXPERTS]: searchResponse,
  [FAILURE_EXPERTS]: failureResponse,
  [FAILURE_PROFILE_EXPERTS]: failureResponse,
  [FAILURE_AFFILIATION_PROFILE_EXPERTS]: failureResponse,
  [FAILURE_TRIALS]: failureResponse,
  [TOPIC_ARTICLES_FAILURE]: failureResponse,
  [FAILURE_PEER_REVIEW]: failureResponse,
  [FAILURE_INSTITUTE]: failureResponse,
  [GET_SOCMED_CITATION_FAILURE]: failureResponse,
  [SENIOR_SCHEMA_FAILURE]: seniorityFailure,
  [GET_AFF_TRIALS_FAILURE]: failureResponse,
  [EXPERT_CREDENTIALS_FAILURE]: expertCredentialsFailure,
  [AFF_CREDENTIALS_FAILURE]: affCredentialsFailure,
  [FAILURE_SENIORITY_EXPERTS]: failureResponse,
  // [RESPONSE_TRIALS_ID]: searchResponse,
  // [FAILURE_TRIALS_ID]: failureResponse
  //New analytics
  [MLD_PROFESSIONALS_RESPONSE]: MldsearchResponse,
  [MLD_SELECTED_LIST_PROFESSIONALS_RESPONSE]: MldsearchResponse,
  [MLD_SHORT_LIST_PROFESSIONALS_RESPONSE]: MldsearchResponse,
  // [RESPONSE_LOCATION_MLD]: MldsearchResponse,
  [MLD_SOCIAL_BODY_RESPONSE]: MldsearchResponse,
  [RESPONSE_MLD_TRIALS]: MldsearchResponse,
  [MLD_SOCIAL_CONF_RESPONSE]: MldsearchResponse,
  [EURO_NETWORK_RESPONSE]: MldsearchResponse,
  // [MLD_AFFILIATIONS_RESPONSE]: MldsearchResponse,
  [MLD_PROFESSIONALS_FAILURE]: MldsearchFailure,
  // [FAILURE_LOCATION_MLD]: MldsearchFailure,
  [MLD_SOCIAL_BODY_FAILURE]: MldsearchFailure,
  [FAILURE_MLD_TRIALS]: MldsearchFailure,
  [MLD_SOCIAL_CONF_FAILURE]: MldsearchFailure,
  [EURO_NETWORK_FAILURE]: MldsearchFailure,
  // [MLD_AFFILIATIONS_FAILURE]: MldsearchFailure,
  [MLD_SHORT_LIST_PROFESSIONALS_FAILURE]: MldsearchFailure,
  [MLD_SELECTED_LIST_PROFESSIONALS_FAILURE]: MldsearchFailure,
  [RESPONSE_TRIALS_INSTITUTES]: TrialsRsearchResponse,
  [RESPONSE_TRIALS_ENDPOINTS]: TrialsEndPointResponse,

  [APP_EXPERTS_SEARCH_RESPONSE]: searchResponse,
  [APP_EXPERTS_SEARCH_FAILURE]: failureResponse,
  [APP_TRIALS_RESPONSE]: searchResponse,
  [APP_TRIALS_FAILURE]: failureResponse,
  [RESPONSE_ZOGENIX_SPAIN_SEARCH]: spainSearchResponse,
  [FAILURE_ZOGENIX_SPAIN_SEARCH]: spainSearchFailure,
  [RESPONSE_DIRECT_PROFILE_SEARCH]: (action, store) => {
    let { name, filters } = action.payload;

    const payload = {
      name,
      filters
    };

    return commonResponse(action, payload);
  },
  [FAILURE_DIRECT_PROFILE_SEARCH]: (action, store) => {
    let { name, filters } = action.payload;

    const payload = {
      name,
      filters
    };

    return commonResponse(action, payload);
  },

  COMMON_ANALTYICS: (action, store) => {
    let { info } = action.payload;
    const payload = {
      info
    };

    return commonResponse(action, payload);
  }
};

export default eventTypesMap;
